/* eslint no-unused-vars: "off" */
import axios from 'axios'
import qs from 'qs'
import uuid from './uuid'
import cookieUtil from './cookieUtil'
import userAgentHelper from './userAgentHelper'
import sessionStorageUtil from './sessionStorageUtil'
import {getAuth} from '../mixins/authorize'
import store from '@/store';

// 不需要加header的地址
const noHeaderServers = [
  'www.mgzf.com',
  'broker.api.mgzf.com',
  's.mgzf.com',
  'assets.mgzf.com',
  'api.mgzf.com/mogoroom-renterembed/renterPay',
  'api.mgzf.com/mogoroom-renterembed/sales',
  'api.mgzf.com/mogoroom-renterembed/bookOrderNew',
  'api.mgzf.com/mogoroom-renterembed/signedOrderNew',
  'api.mgzf.com/mogoroom-renterembed/support',
  'api.mgzf.com/mogoroom-renterembed/file',
  'api.mgzf.com/mogoroom-renterembed/renterAccountNew',
  'app.api.mgzf.com',
  'restapi.amap.com'
];

// 需要加withCredentials的地址
const crosServers = window.location.href.indexOf('localhost') > -1 ? [] : ['www.mgzf.com'];

/**
 * 接口url校验 是否需要添加header
 * @param {Object} context : axios config
 * @returns {Boolean}
 */
function existIncludeServer(config) {
  return noHeaderServers.some(str => {
    return (config.url.indexOf('http') === 0
      ? config.url
      : config.baseURL + config.url || '')
      .indexOf(str) > -1
  })
}

function crosServersProcess(config) {
  if (crosServers.some(str => {
      return (config.url.indexOf('http') === 0
        ? config.url
        : config.baseURL || '')
        .indexOf(str) >= 0
    })) {
    config.withCredentials = true
  }
}

function channelProcess(config) {
  if (config.channel) {
    config.headers.Channel = config.channel;
    return;
  }
}

function brandCustomProcess(config) {
  if (!sessionStorageUtil.get().landlordNo) return;
  if (config.onlyChannel && config.brandCustom) {
    config.headers.Channel = 35;
    return;
  }
  if (config.brandCustom) {
    config.headers.landlordNo = sessionStorageUtil.get().landlordNo
    config.headers.Channel = 35;
    config.headers.os = userAgentHelper.os;
  }
  if(config.brandCustomBody) {
    if (config.method === 'get') {
      config.params = config.params || {}
      config.params.landlordNo = sessionStorageUtil.get().landlordNo;
    } else {
      config.data = config.data || {}
      config.data.landlordNo = sessionStorageUtil.get().landlordNo;
    }
  }
}

if (!cookieUtil.getCookie('uuid')) {
  cookieUtil.setCookie('uuid', uuid())
}

axios.defaults.baseURL = 'https://api.mgzf.com/mogoroom-find';
axios.defaults.baseRenterCenter = 'https://api.mgzf.com/mogoroom-rentercenter';
axios.defaults.baseMgzfURL = 'https://www.mgzf.com';
axios.defaults.brokerAPP = 'https://broker.api.mgzf.com/broker-app';
axios.defaults.baseRenterbehavior = 'https://api.mgzf.com/mogoroom-renter-behavior';
axios.defaults.authorize = 'https://api.mgzf.com/mogoroom-renterauthorize';
axios.defaults.analytics = 'https://s.mgzf.com';
axios.defaults.assetsMgzfFind = 'https://assets.mgzf.com/find_prod';
axios.defaults.custSeek = 'https://cust-seek.mgzf.com/cust-seek';
axios.defaults.rcmdMgzf = 'https://rcmd.mgzf.com/cust-rcmd';//自动化房源推荐新服务
axios.defaults.saleUrl = 'https://api.mgzf.com/renterembed-sale';
axios.defaults.loanUrl = 'https://api.mgzf.com/renterembed-loan';
axios.defaults.commbiz = 'https://api.mgzf.com/commbiz';
axios.defaults.renterEmbed = 'https://api.mgzf.com/mogoroom-renterembed';
axios.defaults.roomFindWeb = 'https://api.mgzf.com/room-find-web';

axios.defaults.renterOperation = 'https://api.mgzf.com/renter-operation/';

axios.defaults.renterCoupon = 'https://api.mgzf.com/mrkt-web';
axios.defaults.assetsMgzf = 'https://assets.mgzf.com';
axios.defaults.api = 'https://api.mgzf.com';
axios.defaults.mrktWeb = 'https://api.mgzf.com/mrkt-web/';
axios.defaults.qmtUrl = 'https://api.mgzf.com/qmt-bs/';

// 添加请求拦截器
axios.interceptors.request.use(
  function (config) {
    let auth = getAuth();
    let mogo_default = JSON.parse(localStorage.getItem('mogo_default') || '{}');
    if (!existIncludeServer(config)) {
      config.headers.userId = auth.userId || mogo_default.userId || '';
      config.headers.Token = auth.token || mogo_default.token || '';
      if (!cookieUtil.getCookie('uuid')) {
        cookieUtil.setCookie('uuid', uuid())
      }
      config.headers.Channel = userAgentHelper.channelHeader;
      config.headers.UUID = cookieUtil.getCookie('uuid');
      brandCustomProcess(config);
    }

    crosServersProcess(config);
    channelProcess(config);

    if (config.json) {
      return config
    }
    if (config.method === 'get' || config.method === 'put') {
      config.params = config.params || {}
      config.data = qs.stringify(config.params)
    } else {
      config.data = config.data || {}
      config.data = qs.stringify(config.data)
    }
    return config
  },
  function (error) {
    // 对请求错误做些什么
    return Promise.reject(error)
  }
);
// 添加响应拦截器
axios.interceptors.response.use(function (response) {
  //S233020 登录异常
  //S233021 登录已过期
  //todo最新api 登录失效code码，S233000001
  if (response.data.code == 'S233020' ||
  response.data.code == 'S233021' ||
  response.data.code == '20000' ||
  response.data.code == '20003' ||
  response.data.code == 'S233000001' ||
  
  (response.data.head && response.data.head.code == '20003')) {
    store.dispatch("resetAuth");
    if (userAgentHelper.isAliMini() &&  response.data.code != '20000') {
      window.my && window.my.postMessage({type: 'login', data: {url: location.href}}); // 支付宝小程序登陆
      return Promise.reject(new Error() + '支付宝小程序登陆....')
    }
  }
  // 对响应数据做点什么
  return response
}, function (error) {
  if (userAgentHelper.browser === 'ali' &&
    (error.config.url.indexOf('/wapHome/cityList') >= 0 ||
      error.config.url.indexOf('/wapHome/first') >= 0 ||
      error.config.url.indexOf('/wapHome/second') >= 0)) {
    window.location.reload()
  }
  return Promise.reject(error)
})

export default axios



// WEBPACK FOOTER //
// ./src/library/axiosConfig.js